import { Box, styled, Typography } from "@mui/material"
import { useLocalization } from "@tm/localization"
import { Image } from "../../../../image"

type Props = {
    iconPath: string
    application: string
}

const StyledDetailsBox = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "1em",
    padding: "0.25em",
})

const StyledImage = styled(Image)({
    objectFit: "contain",
    height: "48px",
    width: "auto",
})

export default function TruckTyrePositionTooltip({ iconPath, application }: Props) {
    const { translateText } = useLocalization()

    return (
        <StyledDetailsBox>
            <Typography variant="body2">{translateText(14006)}</Typography>
            <StyledImage src={iconPath} />
            <Box display="flex" gap="0.25em">
                <Typography variant="body3">{translateText(1782)}</Typography>
                <Typography variant="body3" fontWeight="bold">
                    {application}
                </Typography>
            </Box>
        </StyledDetailsBox>
    )
}
